// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19UUj","field":"styles_field__3FxHk","fieldCol":"styles_fieldCol__9es9d","diffCol":"styles_diffCol__1cH3s","diff":"styles_diff__294F0"};